import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Label } from "@/components/ui/label";

interface ProfileHierarchySectionProps {
  hierarchy: string;
  onHierarchyChange: (value: string) => void;
  loading: boolean;
}

const hierarchyOptions = [
  { 
    value: "Alpha", 
    label: "Alpha", 
    description: "Dominant, leader" 
  },
  { 
    value: "Beta", 
    label: "Beta", 
    description: "Supportive follower" 
  },
  { 
    value: "Gamma", 
    label: "Gamma", 
    description: "Intelligent outsider" 
  },
  { 
    value: "Delta", 
    label: "Delta", 
    description: "Average, silent worker" 
  },
  { 
    value: "Sigma", 
    label: "Sigma", 
    description: "Lone wolf" 
  },
  { 
    value: "Omega", 
    label: "Omega", 
    description: "Submissive, bottom" 
  }
];

export const ProfileHierarchySection = ({
  hierarchy,
  onHierarchyChange,
  loading
}: ProfileHierarchySectionProps) => {
  return (
    <div>
      <Label htmlFor="hierarchy" className="text-ice-white mb-2 block">Hierarchy</Label>
      <Select value={hierarchy} onValueChange={onHierarchyChange} disabled={loading}>
        <SelectTrigger className="bg-carbon border-ice-white/20 text-ice-white">
          <SelectValue placeholder="Select your hierarchy type" />
        </SelectTrigger>
        <SelectContent className="bg-carbon border-ice-white/20">
          {hierarchyOptions.map((option) => (
            <SelectItem 
              key={option.value} 
              value={option.value} 
              className="text-ice-white hover:bg-ice-white/10 pl-4"
            >
              {option.label} - {option.description}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};